import { render, staticRenderFns } from "./EmailConfirm.vue?vue&type=template&id=9ff06c88"
import script from "./EmailConfirm.vue?vue&type=script&lang=js"
export * from "./EmailConfirm.vue?vue&type=script&lang=js"
import style0 from "./EmailConfirm.vue?vue&type=style&index=0&id=9ff06c88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports